import { render } from "./createTicket.vue?vue&type=template&id=36896929&scoped=true"
import script from "./createTicket.vue?vue&type=script&lang=js"
export * from "./createTicket.vue?vue&type=script&lang=js"

import "./createTicket.vue?vue&type=style&index=0&id=36896929&lang=less&scoped=true"
import "./createTicket.vue?vue&type=style&index=1&id=36896929&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36896929"]])

export default __exports__